


































import { Component, Vue, Inject, InjectReactive } from 'vue-property-decorator'
import { CurrentUser } from '@/_interfaces/CurrentUser'

@Component({})
export default class NavbarDropdownMenu extends Vue {
  @Inject('logout')
  clickLogout!: () => void

  @Inject('is-observer')
  readOnly!: () => boolean

  @InjectReactive('user')
  user!: CurrentUser

  get isCollapsible() {
    /*
     - Collapsible dropdown on mobile view will be disabled when access right is Observer role
     - If using !readOnly, this maybe make some confuse with another role when review code
    */
    return this.readOnly() ? false : true
  }
}
